import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  rootContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: "24px",
    width: "100%",
    boxSizing: "border-box",
    // minHeight: "460px",
  },

  flexItem50: {
    flex: "1 1 calc(50% - 12px)", // 50% minus half of the gap for proper spacing
    minWidth: "300px", // optional, ensures decent layout on narrow screens
    boxSizing: "border-box",
  },

  flexItemFull: {
    flex: "1 1 100%", // Full width when only one item
    boxSizing: "border-box",
  },

  root: {
    // display: "grid",
    // gridTemplateColumns: "repeat(4, 1fr)",
    // gridTemplateRows: "160px auto auto auto",
    // columnGap: "15px",
    // rowGap: "15px",
    display: "flex",
    flexDirection: "column",
    gap: "30px",
    borderRadius: "25px",
    [theme.breakpoints.down("md")]: {
      marginBottom: 50,
    },
    height: "calc(100vh - 170px)",
    overflowY: "scroll",
  },
  activeAgent: {
    gridColumnStart: 1,
    gridColumnEnd: 3,
    [theme.breakpoints.down("sm")]: {
      gridColumnStart: 1,
      gridColumnEnd: 5,
    },
  },
  pendingChatsAgent: {
    gridColumnStart: 1,
    gridColumnEnd: 5,
  },
  pendingChats: {
    gridColumnStart: 3,
    gridColumnEnd: 5,
    [theme.breakpoints.down("sm")]: {
      gridColumnStart: 1,
      gridColumnEnd: 5,
    },
  },
  agentView: {
    gridColumnStart: 1,
    gridColumnEnd: 5,
  },
  facebookChats: {
    gridColumnStart: 1,
    gridColumnEnd: 3,
    [theme.breakpoints.down("sm")]: {
      gridColumnStart: 1,
      gridColumnEnd: 5,
    },
  },
  whatsappChats: {
    gridColumnStart: 3,
    gridColumnEnd: 5,
    [theme.breakpoints.down("sm")]: {
      gridColumnStart: 1,
      gridColumnEnd: 5,
    },
  },
  graphData: {
    gridColumnStart: 1,
    gridColumnEnd: 4,
    [theme.breakpoints.down("sm")]: {
      gridColumnStart: 1,
      gridColumnEnd: 5,
    },
  },
  chatStatistics: {
    gridColumnStart: 4,
    gridColumnEnd: 5,
    [theme.breakpoints.down("sm")]: {
      gridColumnStart: 1,
      gridColumnEnd: 5,
    },
  },
  pagesBreakdownGraph: {
    gridColumnStart: 1,
    gridColumnEnd: 4,
    [theme.breakpoints.down("sm")]: {
      gridColumnStart: 1,
      gridColumnEnd: 5,
    },
  },
  pagesBreakdownGraphList: {
    gridColumnStart: 4,
    gridColumnEnd: 5,
    [theme.breakpoints.down("sm")]: {
      gridColumnStart: 1,
      gridColumnEnd: 5,
    },
  },
}));

export default useStyles;
